"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
function useOnClickOutside(ref, handler, mouseEvent) {
    if (mouseEvent === void 0) { mouseEvent = 'mousedown'; }
    var callback = React.useRef(handler);
    React.useLayoutEffect(function () {
        callback.current = handler;
    }, [handler]);
    React.useEffect(function () {
        var listener = function (event) {
            var el = ref === null || ref === void 0 ? void 0 : ref.current;
            if (!el || el.contains(event.target)) {
                return;
            }
            callback.current(event);
        };
        window.addEventListener(mouseEvent, listener);
        return function () {
            window.removeEventListener(mouseEvent, listener);
        };
    }, [ref, callback, mouseEvent]);
}
/**
 * @deprecated
 */
exports.default = useOnClickOutside;
